import ssrs from './SSRs'
import specialSSRModal from './specialSSRModal'

export default {
  ssrs,
  specialSSRModal
}
